// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__BmUou","text":"hero_text__ydN4n","numbers":"hero_numbers__ZxKnr","number":"hero_number__8DVIQ","img":"hero_img__rQ6mn"};